/**
 * Higher order function that abstracts try catch error handling
 *
 * @param {function} fn - function to invoke
 * @param {*} valueIfError - fallback return value if function errors
 * @param {*} fnArgs - arguments that are passed into fn. There is no limit on quantity
 * @returns {*} return value of fn or valueIfError
 *
 * @example
 *     const testFunc = (value) => value
 *     withTryCatch(testFunc, 'fallback value', 'fn arg')
 *     -> 'fn arg'
 */
import { logError } from '~/utilities/errorHandlers';

const withTryCatch = <T = any>(
  fn: (...args: any[]) => T,
  valueIfError: T,
  ...fnArgs
) => {
  try {
    return fn(...fnArgs);
  } catch (err) {
    logError(err, { location: 'With Try Catch' });

    return valueIfError;
  }
};

export default withTryCatch;
